<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				ref='table'
				border
				stripe
				:height="tableHeight"
				@select="handleSelectionChange"
				@select-all="handleSelectionChange"
			>
				<el-table-column
					type="selection"
					align="center"
					width="50">
				</el-table-column>
				<el-table-column
					prop="createDate"
					label="时间"
					fixed="left"
					align="center">
				</el-table-column>
				<!-- <el-table-column
					prop="customerName"
					label="付款方/客户"
					fixed="left"
					align="center">
				</el-table-column>
				<el-table-column
					prop="shopName"
					label="店铺名称"
					fixed="left"
					align="center">
				</el-table-column> -->
				<el-table-column
					prop="type"
					label="类型"
					align="center">
					<template slot-scope="scope">
						<div v-if="scope.row.type === 0">充值</div>
						<div v-if="scope.row.type === 1">预付货款充值扣减</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="topMoney"
					label="充值金额（￥）"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.topMoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="deductMoney"
					label="耗用金额(￥)"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.deductMoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop=""
					label="扣减费率"
					align="center">
					<template slot-scope="scope">
						<div v-if="scope.row.type === 1">{{scope.row.deductRatio}}‰</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="serialNumber"
					label="流水号"
					align="center">
				</el-table-column>
				<el-table-column
					prop="paymentSerialNumber"
					label="第三方支付流水号"
					align="center">
				</el-table-column>
				<el-table-column
					prop="payMoney"
					label="订单支付金额"
					align="center">
					<template slot-scope="scope">
						<div v-if="scope.row.type === 1">￥{{scope.row.payMoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="operationName"
					label="经办人"
					align="center"
					width="220">
				</el-table-column>
				<el-table-column
					prop="memo"
					label="备注"
					align="center">
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20,40, 60, 100]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		AuthorityList: {
			type: Object
		}
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			},
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'id',
				selectHandler: this.tableSelectUtilsHandler
			})
		}
	},
	// watch: {
	// 	tableData: {
	// 		handler (val) {
	// 			this.$nextTick(() => {
	// 				this.tableSelectUtils.setTableDefaultSelect(val, this.$refs.table)
	// 			})
	// 		},
	// 		immediate: true
	// 	}
	// },
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	created () {
		// this.getAuthority('07_0001_0000_00')
	},
	methods: {
		clear () {
			this.tableSelectUtils.clear()
		},
		tableSelectUtilsHandler (row) {
			return {
				id: row.id
			}
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			let list = this.ids
			let selectIds = list.map(item => {
				return item.id
			})
			this.$emit('selectIds', selectIds)
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.main-table-box {
		flex: 1
		width: 100%
		// padding-bottom 10px
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
		.product-name {
			display: flex;
			justify-content: center;
			align-items: center;
			.giftLogo{
				margin-right :5px;
				font-size :10px;
				width: 24px;
				height: 18px;
				line-height: 18px;
				color: var(--fx-primary-color);
				border: 1px solid var(--fx-primary-color);
				border-radius :5px;
				flex-shrink: 0
			}
			.p-name {
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
		}
	}
}
</style>
<style lang="stylus">
.main-table {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
	.under-num {
		cursor :pointer;
		color: var(--fx-primary-color);
		text-decoration: underline
		display: flex;
		align-items: center;
	}
	.under-num1 {
		color: var(--fx-primary-color);
		display: flex;
		align-items: center;
		span {
			cursor :pointer;
			text-decoration: underline
		}
		.return-icon {
			margin-left :5px;
			font-size :10px;
			width: 20px;
			height: 18px;
			line-height: 16px;
			color :#EC4141;
			border :1px solid #EC4141;
			border-radius :5px;
			flex-shrink: 0
		}
	}
}
</style>
s
